var map = {
	"./admin/admin.module": [
		"./src/app/admin/admin.module.ts",
		"default~admin-admin-module~annoucements-annoucements-module~bank-details-bank-details-module~course-~c5b029d8",
		"default~admin-admin-module~course-manage-course-manage-module~dashboard-dashboard-module~event-atten~57470bb5",
		"default~admin-admin-module~course-manage-course-manage-module~event-event-module~ticket-ticket-modul~186c61b7",
		"default~admin-admin-module~dashboard-dashboard-module~event-attendee-info-event-attendee-info-module~280d912d",
		"default~admin-admin-module~course-manage-course-manage-module~dashboard-dashboard-module~event-event~388e10cd",
		"default~admin-admin-module~frontend-frontend-module~listing-listing-module~ticket-ticket-module",
		"default~admin-admin-module~dashboard-dashboard-module",
		"common",
		"admin-admin-module"
	],
	"./annoucements/annoucements.module": [
		"./src/app/frontend/dashboard/annoucements/annoucements.module.ts",
		"default~admin-admin-module~annoucements-annoucements-module~bank-details-bank-details-module~course-~c5b029d8",
		"common",
		"annoucements-annoucements-module"
	],
	"./bank-details/bank-details.module": [
		"./src/app/frontend/dashboard/bank-details/bank-details.module.ts",
		"default~admin-admin-module~annoucements-annoucements-module~bank-details-bank-details-module~course-~c5b029d8",
		"common",
		"bank-details-bank-details-module"
	],
	"./course-manage/course-manage.module": [
		"./src/app/frontend/dashboard/course-manage/course-manage.module.ts",
		"default~admin-admin-module~annoucements-annoucements-module~bank-details-bank-details-module~course-~c5b029d8",
		"default~admin-admin-module~course-manage-course-manage-module~dashboard-dashboard-module~event-atten~57470bb5",
		"default~admin-admin-module~course-manage-course-manage-module~event-event-module~ticket-ticket-modul~186c61b7",
		"default~admin-admin-module~course-manage-course-manage-module~dashboard-dashboard-module~event-event~388e10cd",
		"common",
		"course-manage-course-manage-module"
	],
	"./dashboard/dashboard.module": [
		"./src/app/frontend/dashboard/dashboard.module.ts",
		"default~admin-admin-module~annoucements-annoucements-module~bank-details-bank-details-module~course-~c5b029d8",
		"default~admin-admin-module~course-manage-course-manage-module~dashboard-dashboard-module~event-atten~57470bb5",
		"default~admin-admin-module~dashboard-dashboard-module~event-attendee-info-event-attendee-info-module~280d912d",
		"default~admin-admin-module~course-manage-course-manage-module~dashboard-dashboard-module~event-event~388e10cd",
		"default~admin-admin-module~dashboard-dashboard-module",
		"default~dashboard-dashboard-module~frontend-frontend-module",
		"common",
		"dashboard-dashboard-module"
	],
	"./event-attendee-info/event-attendee-info.module": [
		"./src/app/frontend/event-attendee-info/event-attendee-info.module.ts",
		"default~admin-admin-module~course-manage-course-manage-module~dashboard-dashboard-module~event-atten~57470bb5",
		"default~admin-admin-module~dashboard-dashboard-module~event-attendee-info-event-attendee-info-module~280d912d",
		"common",
		"event-attendee-info-event-attendee-info-module"
	],
	"./event/event.module": [
		"./src/app/frontend/dashboard/event/event.module.ts",
		"default~admin-admin-module~annoucements-annoucements-module~bank-details-bank-details-module~course-~c5b029d8",
		"default~admin-admin-module~course-manage-course-manage-module~event-event-module~ticket-ticket-modul~186c61b7",
		"default~admin-admin-module~dashboard-dashboard-module~event-attendee-info-event-attendee-info-module~280d912d",
		"default~admin-admin-module~course-manage-course-manage-module~dashboard-dashboard-module~event-event~388e10cd",
		"common",
		"event-event-module"
	],
	"./frontend/frontend.module": [
		"./src/app/frontend/frontend.module.ts",
		"default~admin-admin-module~annoucements-annoucements-module~bank-details-bank-details-module~course-~c5b029d8",
		"default~admin-admin-module~course-manage-course-manage-module~dashboard-dashboard-module~event-atten~57470bb5",
		"default~admin-admin-module~frontend-frontend-module~listing-listing-module~ticket-ticket-module",
		"default~dashboard-dashboard-module~frontend-frontend-module",
		"default~frontend-frontend-module~tutorial-tutorial-module",
		"common",
		"frontend-frontend-module"
	],
	"./listing/listing.module": [
		"./src/app/frontend/listing/listing.module.ts",
		"default~admin-admin-module~course-manage-course-manage-module~dashboard-dashboard-module~event-atten~57470bb5",
		"default~admin-admin-module~frontend-frontend-module~listing-listing-module~ticket-ticket-module",
		"common",
		"listing-listing-module"
	],
	"./product/product.module": [
		"./src/app/frontend/dashboard/product/product.module.ts",
		"default~admin-admin-module~annoucements-annoucements-module~bank-details-bank-details-module~course-~c5b029d8",
		"common",
		"product-product-module"
	],
	"./reseller/reseller.module": [
		"./src/app/frontend/dashboard/reseller/reseller.module.ts",
		"reseller-reseller-module"
	],
	"./ticket/ticket.module": [
		"./src/app/frontend/dashboard/ticket/ticket.module.ts",
		"default~admin-admin-module~annoucements-annoucements-module~bank-details-bank-details-module~course-~c5b029d8",
		"default~admin-admin-module~course-manage-course-manage-module~event-event-module~ticket-ticket-modul~186c61b7",
		"default~admin-admin-module~frontend-frontend-module~listing-listing-module~ticket-ticket-module",
		"common",
		"ticket-ticket-module"
	],
	"./tutorial/tutorial.module": [
		"./src/app/frontend/tutorial/tutorial.module.ts",
		"default~admin-admin-module~course-manage-course-manage-module~dashboard-dashboard-module~event-atten~57470bb5",
		"default~frontend-frontend-module~tutorial-tutorial-module",
		"common",
		"tutorial-tutorial-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;